module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-1600.a13f024f.svg";